const propelInit = function() {
const formWrappers = document.querySelectorAll('.gform_wrapper');
const config = { childList: true, subtree: true };

formWrappers.forEach((formWrapper) => {
	let isSubmitting = false;

	const observer = new MutationObserver((mutationList) => {
		if (mutationList.length > 0) {
			for (const mutation of mutationList) {
				const loader = mutation.target.querySelector('.gform-loader');

				if (loader) {
					isSubmitting = true;
				}

				const submitButtons =
					mutation.target.querySelectorAll('[type="submit"]');

				submitButtons.forEach((submitButton) => {
					if (loader) {
						submitButton.classList.add('disabled');
					} else {
						submitButton.classList.remove('disabled');
					}
				});

				if (mutation.addedNodes) {
					let confirmationWrapper;

					const hasConfirmationWrapper = Array.from(
						mutation.addedNodes
					).some((node) => {
						if (
							node.classList &&
							node.classList.contains(
								'gform_confirmation_wrapper'
							)
						) {
							confirmationWrapper = node;

							return true;
						}

						return false;
					});

					if (hasConfirmationWrapper) {
						const formId =
							confirmationWrapper?.id.replace(
								'gform_confirmation_wrapper_',
								'gform-'
							) ?? '';

						window.dispatchEvent(
							new CustomEvent('propel-form-submit', {
								detail: { formId, formWrapper },
							})
						);

						isSubmitting = false;

						window.dispatchEvent(
							new CustomEvent('propel-form-submit-success', {
								detail: { formId, formWrapper },
							})
						);

						const blockForm =
							mutation.target.closest('.block-form') ??
							mutation.target.querySelector('.block-form');

						if (blockForm) {
							blockForm.classList.add('block-form--success');
						}

						observer.disconnect();

						break;
					}

					if (
						isSubmitting &&
						!loader &&
						mutation.addedNodes.length > 0
					) {
						window.dispatchEvent(
							new CustomEvent('propel-form-submit', {
								detail: {
									formId: formWrapper.id.replace(
										'gform_wrapper_',
										'gform-'
									),
									formWrapper,
								},
							})
						);

						isSubmitting = false;
					}
				}
			}
		}
	});

	observer.observe(formWrapper.parentElement, config);
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['gravity-forms'] = window.propel.blocks['gravity-forms'] || {};
window.propel.blocks['gravity-forms'].script = propelInit;
